import { Link } from "react-router-dom";
import "./SmallPop.css";

export default function SmallPop(props) {
    
    return <div id="small-pop">  
        <p>{props.text}</p>
        {props.link && <Link to={props.link.to}>
            {props.link.text}
        </Link>}
    </div>
}